import {
  getBroadcasterList,
  getChannelList,
  getProductChannels,
  deleteBroadcaster,
  deleteChannel,
  deleteChannelMapping,
  createBroadcaster,
  getChannelTemplate,
  createChannel,
  getChannelMappingTemplate,
  createProductMapping,
  getBroadcasterById,
  updateBroadcaster,
  getChannelById,
  updateChannel,
  getChannelMappingById,
  updateChannelMapping,
} from "@/http/setup/broadcaster.js";

export default {
  namespaced: true,
  state: {
    broadcasterList: [],
    channelList: [],
    productList: [],
    channelTemplate: {},
    channelMappingTemplate: {},
    broadcasterById: {},
    channelById: {},
    productMappingData: {},
  },
  actions: {
    async setBroadcasterList({ commit }) {
      try {
        const response = await getBroadcasterList();
        commit("SET_BROADCASTER_LIST", response.data.pageItems);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setChannelList({ commit }) {
      try {
        const response = await getChannelList();
        commit("SET_CHANNEL_LIST", response.data.pageItems);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setProductMappingList({ commit }) {
      try {
        const response = await getProductChannels();
        commit("SET_PRODUCTMAPPING_LIST", response.data.pageItems);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async deleteBroadcasterAction({ commit }, id) {
      try {
        return await deleteBroadcaster(id);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },

    async deleteChannelAction({ commit }, id) {
      try {
        return await deleteChannel(id);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async deleteChannelMappingAction({ commit }, id) {
      try {
        return await deleteChannelMapping(id);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createBroadcasterAction({ commit }, data) {
      try {
        return await createBroadcaster(data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setChannelTemplate({ commit }) {
      try {
        const resp = await getChannelTemplate();
        commit("SET_CHANNEL_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createChannelAction({ commit }, data) {
      try {
        return await createChannel(data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setChannelMappingTemplate({ commit }, data) {
      try {
        const resp = await getChannelMappingTemplate();
        commit("SET_CHANNEL_MAPPING_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async createProductMappingAction({ commit }, data) {
      try {
        return await createProductMapping(data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setBroadcasterById({ commit }, id) {
      try {
        const resp = await getBroadcasterById(id);
        commit("SET_BROADCASTER_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async editBroadcasterAction({ commit }, data) {
      try {
        return await updateBroadcaster(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setChannelById({ commit }, id) {
      try {
        const resp = await getChannelById(id);
        commit("SET_CHANNEL_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async updateChannelAction({ commit }, data) {
      try {
        return await updateChannel(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setProductMappingById({ commit }, id) {
      try {
        const resp = await getChannelMappingById(id);
        commit("SET_PRODUCT_MAPPING_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async updateProductMappingAction({ commit }, data) {
      try {
        return await updateChannelMapping(data.id, data.data);
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
  },
  mutations: {
    SET_BROADCASTER_LIST(state, payload) {
      state.broadcasterList = payload;
    },
    SET_CHANNEL_LIST(state, payload) {
      state.channelList = payload;
    },
    SET_PRODUCTMAPPING_LIST(state, payload) {
      state.productList = payload;
    },
    SET_CHANNEL_TEMPLATE(state, payload) {
      state.channelTemplate = payload;
    },
    SET_CHANNEL_MAPPING_TEMPLATE(state, payload) {
      state.channelMappingTemplate = payload;
    },
    SET_BROADCASTER_BY_ID(state, payload) {
      state.broadcasterById = payload;
    },
    SET_CHANNEL_BY_ID(state, payload) {
      state.channelById = payload;
    },
    SET_PRODUCT_MAPPING_BY_ID(state, payload) {
      state.productMappingData = payload;
    },
  },
};
